<template>
  <div>
    <div class="container">
      <div class="row text-left">
        <div class="col-md-7 p-4">
          <img src="@/assets/img/error.svg" class="img-fluid" />
        </div>
        <div class="col-md-5 align-self-center">
          <h1 class="h4">Unable to connect to the API server!</h1>
          <p class="lead mb-1">Our team has been notified about this incident.</p>
          <p class="font-weight-normal text-muted mb-3"><strong>Note:</strong> This doesn't affect your AMP store.</p>

          <button class="btn btn-primary" @click="refresh">Retry</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    refresh: function () {
      window.location.reload(true)
    }
  }
}
</script>
